// extracted by mini-css-extract-plugin
module.exports = {"pintxo-skeleton":"Skeleton_pintxo-skeleton__BcQPt","pintxo-skeleton-shape":"Skeleton_pintxo-skeleton-shape__RuB6c","fill-animation":"Skeleton_fill-animation__cMi2t"};